const state = () => ({
  dlpData: {
    heading: '',
    subheading: '',
    description: '',
    keywords: [],
    lightboxes: [],
  },
  backgroundImageUrl: '',
  elements: [],
  collections: [],
  dynamicElementsByMediaType: [],
});

const getters = {
  dlpData: ({ dlpData }) => dlpData,
  backgroundImageUrl: ({ backgroundImageUrl }) => backgroundImageUrl,
  keywords: ({ dlpData }) => dlpData.keywords,
  collections: ({ collections }) => collections,
  elements: ({ elements }) => elements,
  lightboxes: ({ dlpData }) => dlpData.lightboxes,
  mediaTypes: ({ dlpData }) => dlpData.mediaTypes || [],
  heading: ({ dlpData }) => dlpData.heading,
  description: ({ dlpData }) => dlpData.description || dlpData.subheading,
  subheading: ({ dlpData }) => dlpData.subheading,
  dynamicElementsByMediaType: ({ dynamicElementsByMediaType }) => dynamicElementsByMediaType,
};

const mutations = {
  setDlpData(state, data) {
    state.dlpData = data;
  },
  setBackgroundImageUrl(state, url) {
    state.backgroundImageUrl = url;
  },
  setDynamicElementsByMediaType(state, data) {
    state.dynamicElementsByMediaType.push(data);
  },
};

const actions = {
  searchDlpElementsByMediaTypes({ commit }, { keywords, mediaType }) {
    return import('@/api/search.js').then(({ searchElements }) => searchElements(mediaType, { s: keywords, per_page: 12 }).then((response) => {
      const elements = response.data.data;
      if (Array.isArray(elements) && elements.length) {
        commit('setDynamicElementsByMediaType', { mediaType, elements });
      }
      return response;
    }));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
